import React from "react";
import PropTypes from "prop-types";
import DataUtils from "../../../../utils/dataUtils";
import MobileRewardsWrapper from "./MobileRewardsWrapper";
import { LocalizationMessages } from "../../../../localization/messages";
import { ClientProviderEnum, MyAccountTab } from "../../../../constants";
import RewardBox from "./RewardBox/RewardBox";
import { useAccountCommunicationHandlers } from "../../../../hooks";
import { useIntl } from "react-intl";
import { ClientProviderUtils } from "../../../../utils/clientProviderUtils";

const MobileRewards = props => {
  const { trackingInfo } = props;
  const rewardsSectionComponents = DataUtils.getDataStoreValue(
    "RewardsSectionComponents"
  );
  const clientProvider = ClientProviderUtils.getClientProvider();
  const { openMyAccount } = useAccountCommunicationHandlers();
  const { formatMessage } = useIntl();

  return (
    <MobileRewardsWrapper>
      {rewardsSectionComponents?.map((comp, index) => {
        const components = {
          FREE_BETS: (
            <RewardBox
              iconName="free-bets"
              linkText={formatMessage(LocalizationMessages.freeBets)}
              handleClick={() =>
                openMyAccount({
                  tabId:
                    clientProvider === ClientProviderEnum.Kambi
                      ? MyAccountTab.FreeBets
                      : MyAccountTab.FreeBetsSpectate
                })
              }
              dataTestId={`uc-free-bets-${index}`}
              trackingInfo={{
                ...trackingInfo,
                dataLabel: "Rewards - Free Bets"
              }}
              bonusDescription={formatMessage(
                LocalizationMessages.freeBetsBelowtext
              )}
            />
          ),
          BONUSES: (
            <RewardBox
              iconName="bonuses"
              linkText={formatMessage(LocalizationMessages.bonuses)}
              handleClick={() =>
                openMyAccount({ tabId: MyAccountTab.RewardsPWC })
              }
              dataTestId={`uc-bonuses-${index}`}
              trackingInfo={{
                ...trackingInfo,
                dataLabel: "Rewards - Bonuses"
              }}
              bonusDescription={formatMessage(
                LocalizationMessages.bonusesBelowText
              )}
            />
          ),
          FREE_PLAY: (
            <RewardBox
              iconName="free-play"
              linkText={formatMessage(LocalizationMessages.freePlay)}
              handleClick={() =>
                openMyAccount({ tabId: MyAccountTab.FreePlay })
              }
              dataTestId={`uc-free-play-${index}`}
              trackingInfo={{
                ...trackingInfo,
                dataLabel: "Rewards - Free Play"
              }}
              bonusDescription={formatMessage(
                LocalizationMessages.freePlayBelowText
              )}
            />
          ),
          TOURNAMENTS_TICKETS: (
            <RewardBox
              iconName="tournament-tickets"
              linkText={formatMessage(LocalizationMessages.tournamentTickets)}
              handleClick={() => openMyAccount({ tabId: MyAccountTab.TRT })}
              dataTestId={`uc-tournament-tickets-${index}`}
              trackingInfo={{
                ...trackingInfo,
                dataLabel: "Rewards - Tournament Tickets"
              }}
              bonusDescription={formatMessage(
                LocalizationMessages.tournamentTicketsBelowtext
              )}
              isExpandable={false}
            />
          ),
          SI_VOUCHERS: (
            <RewardBox
              iconName="bonuses"
              linkText={formatMessage(LocalizationMessages.SIvouchers)}
              handleClick={() =>
                openMyAccount({ tabId: MyAccountTab.SiVouchers })
              }
              dataTestId={`si-voucher-${index}`}
              trackingInfo={{
                ...trackingInfo,
                dataLabel: "Rewards - SI Vouchers"
              }}
              bonusDescription={formatMessage(
                LocalizationMessages.SIvouchersBelowtext
              )}
            />
          )
        };
        return components[comp] || null;
      })}
    </MobileRewardsWrapper>
  );
};

MobileRewards.propTypes = {
  trackingInfo: PropTypes.object
};
export default React.memo(MobileRewards);
